import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { useContactDialog } from "../context/ContactDialogContext";

const INCLUDED = [
  "Obegränsat antal konserter",
  "Hantering av orkestersektioner & inhyrda musiker",
  "Ljud, ljus, transport, hotell och catering",
  "Reklam, PR och övriga kostnadsposter",
  "Ärendehantering med ansvariga och deadlines",
  "Avtalshantering och engagemangsavtal",
  "Komplett dokumentarkiv",
  "Musiker- och personregister",
  "Resursregister med dokumentlagring",
  "Anpassningsbara inställningar och kategorier",
  "Säker molnbaserad lagring",
  "Löpande uppdateringar och support",
];

const Pricing = () => {
  const { openDialog } = useContactDialog();
  return (
    <div data-testid="page-pricing">
      <section className="pt-32 pb-12">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 text-center">
          <span className="text-xs uppercase tracking-[0.3em] text-[#d4af37]">
            Priser
          </span>
          <h1 className="mt-6 font-serif text-5xl md:text-6xl text-white leading-[1.05]">
            Enkelt och <span className="italic gold-text">transparent.</span>
          </h1>
          <p className="mt-6 text-white/70 leading-relaxed">
            Ett pris. Allt ingår. Ingen modulavgift, inga dolda kostnader. Välj
            en årsprenumeration och få tillgång till hela Orkesteradmin.
          </p>
        </div>
      </section>

      <section className="pb-24" data-testid="pricing-card-section">
        <div className="max-w-2xl mx-auto px-6 lg:px-10">
          <div
            className="relative rounded-3xl border border-[#d4af37]/30 bg-gradient-to-b from-[#0a1128] to-[#111a31] p-10 md:p-14 shadow-[0_0_60px_-20px_rgba(212,175,55,0.25)]"
            data-testid="pricing-card"
          >
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <span className="bg-[#d4af37] text-[#0a1128] px-4 py-1 rounded-full text-xs font-bold uppercase tracking-[0.25em]">
                Årsprenumeration
              </span>
            </div>

            <div className="text-center">
              <h2 className="font-serif text-3xl text-white">
                Orkesteradmin Komplett
              </h2>
              <p className="mt-2 text-white/65 text-sm">
                Hela plattformen för din orkester – ett pris per år.
              </p>
              <p className="mt-1 text-white/65 text-sm" data-testid="pricing-included-users">
                Ingår upp till 6 användare
              </p>

              <div className="mt-10 flex flex-col items-center gap-1">
                <div className="flex items-baseline justify-center gap-2">
                  <span
                    className="font-serif text-6xl md:text-7xl gold-text"
                    data-testid="pricing-amount"
                  >
                    2 880&nbsp;kr
                  </span>
                  <span className="text-white/60 text-lg">/ år</span>
                </div>
                <p className="text-sm text-white/55" data-testid="pricing-amount-vat">
                  Exkl. moms · 3 600&nbsp;kr inkl. moms
                </p>
              </div>

              <a
                href="https://buy.stripe.com/aFadR9abVcqv23F94H9EI0E"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="pricing-cta-order-button"
                className="mt-10 btn-gold inline-flex items-center gap-2 px-8 py-4 rounded-full"
              >
                Beställ <ArrowRight className="w-4 h-4" />
              </a>
            </div>

            <div className="my-10 h-px bg-white/10" />

            <h3 className="font-serif text-xl text-white mb-6 text-center">
              Det här ingår
            </h3>
            <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3" data-testid="pricing-included-list">
              {INCLUDED.map((item, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 text-white/80 text-sm"
                  data-testid={`pricing-included-${i}`}
                >
                  <Check className="w-4 h-4 text-[#d4af37] mt-0.5 shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-10 text-center">
            <p className="text-white/55 text-sm">
              Är ni en större orkester med särskilda behov?{" "}
              <button
                type="button"
                onClick={() => openDialog(null)}
                data-testid="pricing-enterprise-link"
                className="gold-text hover:underline bg-transparent inline"
              >
                Hör av er
              </button>{" "}
              så hittar vi en lösning som passar.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Pricing;
